// NotFound.jsx
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import temisa404 from '../images/lookingLight.png'

function NotFound() {
  const { themeClass} = useTheme();
  const navigate = useNavigate();
  const back = () => {
      if (window.history.length > 1) {
          navigate(-1);
      } else {
          navigate('/'); // Ruta de respaldo
      }
  };

  return (
    <div className='error404page'>
      <img src={temisa404} alt="404" className="temisLooking"/>
      <div className={`text404 ${themeClass}`}>
        <div className={`h1404 ${themeClass}`}>Ooops!</div>
        <h2>¡Te hemos perdido! No sabemos lo que ha podido pasar...</h2>
        <p>Pero, ¿dónde te has metido? No te preocupes, vuelve con nosotros.</p>
      </div>
      <div className='sigup-b'>
          <button className={`color-button ${themeClass}`} onClick={back} type='submit'>
              Volver
          </button>
      </div>
    </div>
  );
}

export default NotFound;